<template>
  <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="600px">
    <v-card>
      <v-card-title class="headline">{{ title }}</v-card-title>
      <v-card-text>
        <p>Please review the following changes:</p>
        <ul v-if="changes.length">
          <li v-for="(change, index) in changes" :key="index">{{ change }}</li>
        </ul>
        <p v-else>No changes detected.</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="$emit('cancel')">Cancel</v-btn>
        <v-btn color="primary" text @click="$emit('confirm')">Update User</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ChangesConfirmationModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    changes: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:modelValue', 'confirm', 'cancel'],
};
</script>
